export default __webpack_public_path__ + "static/media/428.bb033bb5.png";